<template>
  <div id="app">

    <ElementsContainerUnder :state='gameState'/>

    <transition name="fade">

      <CardStart @start="start()" v-show="gameState === 'start'"/>

    </transition>

    <transition name="fade">

      <TestContainer
        @finish="finish"
        v-show="gameState === 'test'"
        @goQuestion="handleMetric"
      />

    </transition>

    <transition name="fade">

      <CardFinal
        :rightAnswers="rightAnswers"
        v-show="gameState === 'final'"
        @goPromo="handleMetric('go_to_clips')"
        @share="handleMetric"
      />

    </transition>

    <transition name="fade">

      <Logo v-show="gameState === 'final'"/>

    </transition>

    <ElementsContainerUpper :state="gameState"/>
  </div>
</template>

<script>
import ElementsContainerUnder from './components/ElementsContainer.vue'
import ElementsContainerUpper from './components/ElementsContainerUpper.vue'
import Logo from './components/Logo.vue'
import CardStart from './components/CardStart.vue'
import CardFinal from './components/CardFinal.vue'
import TestContainer from './components/TestContainer.vue'
import Bridge from '@vkontakte/vk-bridge'

export default {
  name: 'App',

  components: {
    ElementsContainerUnder,
    ElementsContainerUpper,
    Logo,
    CardStart,
    CardFinal,
    TestContainer
  },

  mounted(){
    this.handleMetric('app_launch')

    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`)

    window.addEventListener('resize', () => {
    // We execute the same script as before
      let vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`)
    });
  },

  data(){

    return{

      gameState: 'start',
      rightAnswers: 0,

    }

  },

  methods: {

    start(){

      this.gameState = 'test'

      this.handleMetric('test_started')
    },

    finish(res){

      this.gameState = 'final'
      this.rightAnswers = res
      this.handleMetric('test_passed')
      window.VK.Goal('conversion')
    },

    handleMetric(id, param){
      if (id !== 'view_question') {
        this.$gtag('event', id, param ? {...param} : {});
        window.VK.Retargeting.Event(id);
      }
      Bridge.send("VKWebAppSendCustomEvent", Object.assign(param ? {json: JSON.stringify(param)} : {}, {
        "event": id,
      }))
    }

  }

}
</script>

<style lang="sass" src="./assets/index.sass"></style>
